import React, { useEffect, useState, useCallback } from "react";
import BankPayment from "./components/BankPayment";
import { Routes, Route, Link, useLocation, useParams } from "react-router-dom";

import CardPayment from "./components/CardPayment";
import BankTransactionHistory from "./components/BankTransactionHistory";
import PaymentResponse from "./components/PaymentResponse";
import BalancePayment from "./components/BalancePayment";
import PaypalPayment from "./components/PaypalPayment";
import { PAYMENT_REQUEST_INFO_GET } from "../../utils/api-ends";
import useHttp from "../../hooks/useHttp";
import LoaderImg from "../../assets/media/loader.gif";

const Payment = () => {
  const [paymentRequestDetails, setPaymentRequestDetails] = useState(null);
  const location = useLocation();
  const { paymentRequestId } = useParams();
  const { isLoading, sendRequests } = useHttp();

  const fetchPaymentRequestDetails = useCallback(() => {
    const response = (data) => {
      setPaymentRequestDetails(data?.data);
    };
    sendRequests(
      {
        url: PAYMENT_REQUEST_INFO_GET(paymentRequestId),
      },
      response
    );
  }, [paymentRequestId]);

  useEffect(() => {
    if (paymentRequestId) {
      fetchPaymentRequestDetails();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [paymentRequestId]);

  return (
    <>
      {![
        `/payment/${paymentRequestId}/response`,
        `/payment/${paymentRequestId}/response/`,
      ].includes(location.pathname) && (
        <section className="transaction-section">
          <div className="container theme-section">
            <h1 className="tr-title text-center"> Load Offer Acceptance Payment </h1>

            {isLoading ? (
              <div className="d-flex justify-content-center">
                <img src={LoaderImg} alt="" style={{ width: "50px" }} />
              </div>
            ) : (
              <>
                <p className="tr-small-note" style={{ fontSize: "20px" }}>
                  *** Amount to be paid <b>${paymentRequestDetails?.amount}</b>
                </p>

                <div className="tr-nav-tab-for-payment">
                  <Link to={`/payment/${paymentRequestId}/balance-payment`}>
                    <button
                      className={
                        [
                          `/payment/${paymentRequestId}/balance-payment`,
                          `/payment/${paymentRequestId}/balance-payment/`,
                        ].includes(location.pathname) && "tr-active"
                      }
                    >
                      Balance
                    </button>
                  </Link>
                  <Link to={`/payment/${paymentRequestId}/bank-payment`}>
                    <button
                      className={
                        [
                          `/payment/${paymentRequestId}/bank-payment`,
                          `/payment/${paymentRequestId}/bank-payment/`,
                        ].includes(location.pathname) && "tr-active"
                      }
                    >
                      Bank
                    </button>
                  </Link>

                  <Link to={`/payment/${paymentRequestId}/card-payment`}>
                    <button
                      className={
                        [
                          `/payment/${paymentRequestId}/card-payment`,
                          `/payment/${paymentRequestId}/card-payment/`,
                        ].includes(location.pathname) && "tr-active"
                      }
                    >
                      Card
                    </button>
                  </Link>
                  <Link to={`/payment/${paymentRequestId}/paypal-payment`}>
                    <button
                      className={
                        [
                          `/payment/${paymentRequestId}/paypal-payment`,
                          `/payment/${paymentRequestId}/paypal-payment/`,
                        ].includes(location.pathname) && "tr-active"
                      }
                    >
                      Paypal
                    </button>
                  </Link>
                </div>

                <Routes>
                  <Route
                    path="/card-payment"
                    element={
                      <CardPayment amount={paymentRequestDetails?.amount} />
                    }
                  />
                  <Route path="/bank-payment" element={<BankPayment paymentRequestDetails={paymentRequestDetails}/>} />
                  <Route path="/balance-payment" element={<BalancePayment />} />
                  <Route path="/paypal-payment" element={<PaypalPayment />} />
                </Routes>
              </>
            )}
          </div>
        </section>
      )}

      <Routes>
        <Route path="/bank-payment" element={<BankTransactionHistory />} />
        <Route
          path="/response"
          element={
            <PaymentResponse
              order_id={paymentRequestDetails?.order_id}
              fetchPaymentRequestDetails={fetchPaymentRequestDetails}
            />
          }
        />
      </Routes>
    </>
  );
};

export default Payment;
